import { useForm, SubmitHandler } from "react-hook-form";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { Login, resetStatus } from "../../../store/user";
import Purls from "../../../statics/logo/logo-cpurls.svg";
import { useEffect } from "react";
import { ErrorType } from "../../../store/errorType";
import Error from "../../../components/error";
import packageInfo from "../../../../package.json";
import Modal from "../../../components/modal";
import { useModal } from "../../../customHooks/useModal";
import InfoIcon from '../../../statics/illustrations/info-icon.svg';

/* types */
type FormValues = {
  email: string;
  password: string;
};

const Form = () => {
  const { isShown, toggle } = useModal();
  const dispatch = useAppDispatch();
  const { status, errorMessage, errorType, email } = useAppSelector(
    (state) => state.user
  );
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    defaultValues: {
      email: email !== "" ? email : "",
    },
  });
  const onSubmit: SubmitHandler<FormValues> = async (data) => {
    const send = {
      ...data,
      auth_token_type: 1,
    };
    dispatch(Login(send));
  };
  useEffect(() => {
    if (status === "Login_rejected") {
      dispatch(resetStatus());
    }
  }, []);

  /* const reset =()=>{
    dispatch(resetStatus())
  }
  useEffect(()=>{
    if (status === 'Login_success') {
      navigate('/verify')
      setTimeout((reset), 5000);
    }
  }, [status]) */
  return (
    <>
      <form className="c-login-left__form" onSubmit={handleSubmit(onSubmit)}>
        <img className="c-login-left__logo" src={Purls} alt="PURLs logo" />
        <h2 className="c-login-left__title">Sign In</h2>



        <div className="c-alert--warning">
        
           <span className="icon-wrapper"><img src={InfoIcon} alt="Info Icon"  /></span>
            <span >Emails have been changed from  <span className="bold-text">@freewayinsurance.com</span> to <span className="bold-text">@freeway.com</span>. Please check your login email in case you encounter any problems.</span>
    
</div>


        <span className="c-login-left__version">
          Version: {packageInfo.version}
        </span>
        <div className="c-login-left__input">
          <span className="c-login-left__text-input">Email</span>
          <input
            className="c-login-left__input-value"
            type="email"
            {...register("email", {
              required: "email is required",
              pattern: {
                message: "enter a valid email",
                value: /^\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b$/i,
              },
            })}
          />
        </div>
        {errors.email ? (
          <label className="c-login-left__text-alert">
            {errors.email?.message}
          </label>
        ) : null}

        <div className="c-login-left__input">
          <div className="c-login-left__box-text">
            <span className="c-login-left__text-input">Password</span>
            <Link to="/forgotpassword" className="c-login-left__link">
              Forgot Password?
            </Link>
          </div>
          <input
            className="c-login-left__input-value"
            type="password"
            {...register("password", { required: "password is required" })}
          />
        </div>
        {errors.password ? (
          <label className="c-login-left__text-alert">
            {errors.password?.message}
          </label>
        ) : null}

        {status === "Login_rejected" &&
          errorType === ErrorType.ERROR_SERVER && (
            <Error type="error" message={errorMessage} />
          )}

        {status === "Login_rejected" &&
          errorType === ErrorType.ERROR_PERMISSION && (
            <Error type="problem" message={errorMessage} />
          )}

        {status === "refreshtoken_expired_rejected" &&
          errorType === ErrorType.ERROR_SERVER && (
            <Error type="error" message={errorMessage} />
          )}
        <button
          type="submit"
          className={`c-login-left__input-submit ${
            status === "Login_loading" && `c-login-left__input-submit--disabled`
          }`}
        >
          {status === "Login_loading" ? (
            <>
              <div className="spiner"></div> Loading...
            </>
          ) : (
            <>Sign In</>
          )}
        </button>
        <span className="c-login-left__info">
          If you have any questions or need support, please contact us using{" "}
          <span
            className="c-login-left__info c-login-left__info--link"
            onClick={toggle}
          >
            THIS FORM
          </span>
        </span>
      </form>
      <Modal isActive={isShown} clouse={toggle}>
        <iframe
          width="1024"
          height="768"
          scrolling="no"
          src="https://www.wrike.com/form/eyJhY2NvdW50SWQiOjE1MzAxMDIsInRhc2tGb3JtSWQiOjIwNDI2MjN9CTQ4ODI3Mjg2MTI0NDkJYTJiMWFiNmZkODAxZDViZjAxZDcyZmQyZDhmNTYwM2ZmMmJmYzU2YTYxZDJiMWRmZmNkZjYxNjZlYWZmZTZiYw=="
        ></iframe>
      </Modal>
    </>
  );
};

export default Form;